import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_Pager.scss'
import React from 'react';

function pagerLinks (totalPages, loadPage, currentPage) {
  var pagingLinks = []
  var elipses = 0
  function elipse (keyStart) {
    return <li className={styles['pagination-item']} key={keyStart + totalPages}>...</li>
  }
  const addPagerAnchor = (page, loadPage) => (
    <li className={styles['pagination-item']} key={page}>
      <a onClick={() => loadPage(page)} className={styles['pager-link']}>{page}</a>
    </li>
  )
  const generateLinks = (start, end, loadPage) => {
    for (let i = start; i <= end; i++) {
      if (i === currentPage) {
        pagingLinks.push(<li className={styles['pagination-item']} key={i}>{i}</li>)
      } else {
        pagingLinks.push(addPagerAnchor(i, loadPage))
      }
    }
  }
  if (currentPage <= 2) {
    var pageLimit = totalPages < 4 ? totalPages : 4
    generateLinks(1, pageLimit, loadPage)
    pagingLinks.push(elipse('elipse' + elipses++))
  } else if (currentPage >= 3 && currentPage < totalPages - 2) {
    pagingLinks.push(elipse('elipse' + elipses++))
    generateLinks(currentPage - 1, currentPage + 2, loadPage)
    pagingLinks.push(elipse('elipse' + elipses++))
  } else {
    pagingLinks.push(elipse('elipse' + elipses++))
    generateLinks(currentPage - 2, totalPages, loadPage)
  }
  return pagingLinks
}

function firstPageLink (currentPage, loadPage) {
  if (currentPage === 1) {
    return <li className={styles['pagination-item']}>First</li>
  }
  return <li className={styles['pagination-item']}>
    <a onClick={() => loadPage(1)} className={styles['pager-link']}>First</a>
  </li>
}

function lastPageLink (currentPage, totalPages, loadPage) {
  if (currentPage === totalPages) {
    return <li className={styles['pagination-item']}>Last</li>
  }
  return <li className={styles['pagination-item']}>
    <a onClick={() => loadPage(Math.floor(totalPages))} className={styles['pager-link']}>Last</a>
  </li>
}

const Pager = function ({ totalPages,
    currentPage,
    loadPage
  }) {
  return (totalPages > 1 ? <ul className={styles['pager']}>
    { firstPageLink(currentPage, loadPage) }
    { pagerLinks(totalPages, loadPage, currentPage) }
    { lastPageLink(currentPage, totalPages, loadPage) }
  </ul> : null)
}

Pager.propTypes = {
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  loadPage: PropTypes.func.isRequired
}

export default  (Pager)
